(() => {
  const duration = 250;

  function animateAccordion(details, shouldOpen) {
    const summary = details.querySelector(':scope > summary');
    if (!summary || details.dataset.accordionAnimating === 'true') return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      details.open = shouldOpen;
      return;
    }

    const startHeight = `${details.offsetHeight}px`;
    details.dataset.accordionAnimating = 'true';
    if (shouldOpen) details.open = true;

    const endHeight = shouldOpen ? `${details.scrollHeight}px` : `${summary.offsetHeight}px`;
    details.style.overflow = 'hidden';

    const animation = details.animate(
      { height: [startHeight, endHeight] },
      { duration, easing: 'ease-in-out' }
    );

    animation.onfinish = () => {
      details.open = shouldOpen;
      details.style.height = '';
      details.style.overflow = '';
      delete details.dataset.accordionAnimating;
    };
  }

  function initializeAccordions(root = document) {
    root
      .querySelectorAll(
        '.product__accordion details:not([data-smooth-accordion]), .collapsible-content details:not([data-smooth-accordion]), .careers-section details:not([data-smooth-accordion])'
      )
      .forEach((details) => {
        const summary = details.querySelector(':scope > summary');
        const content = details.querySelector(':scope > .accordion__content');
        if (!summary || !content) return;

        details.dataset.smoothAccordion = 'true';
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          animateAccordion(details, !details.open);
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAccordions());
  } else {
    initializeAccordions();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAccordions(event.target));
})();
